import React from 'react'
import ReactDOM from 'react-dom'
import Main from './Layout/Main'

import './assets/custon.css'
import './assets/base.css'
import 'react-toastify/dist/ReactToastify.min.css'
import 'moment/locale/pt-br'
import apexPtBr from 'apexcharts/dist/locales/pt-br.json'

import { Provider } from 'react-redux'
import storeApp from './Reducers/storeApp'

// Padrão global dos gráficos (ApexCharts não segue o locale do moment)
window.Apex = {
  chart: { locales: [apexPtBr], defaultLocale: 'pt-br', fontFamily: 'inherit', toolbar: { show: false }, zoom: { enabled: false } },
  dataLabels: { enabled: false },
  grid: { borderColor: '#eef0f5', strokeDashArray: 4 },
  tooltip: { theme: 'light' },
}

ReactDOM.render(
  <Provider store={storeApp}>
    <Main />
  </Provider>,
  document.getElementById('root')
)
